var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBandera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 79,
    viewBox: "0 0 54 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2.75581C5 2.02493 4.73661 1.32397 4.26777 0.807159C3.79893 0.290344 3.16304 0 2.5 0C1.83696 0 1.20107 0.290344 0.732233 0.807159C0.263392 1.32397 0 2.02493 0 2.75581V76.2442C0 76.9751 0.263392 77.676 0.732233 78.1928C1.20107 78.7097 1.83696 79 2.5 79C3.16304 79 3.79893 78.7097 4.26777 78.1928C4.73661 77.676 5 76.9751 5 76.2442V2.75581Z",
    fill: "#33993F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3284 10.5593L29.574 10.2602C23.7936 7.98494 17.4682 7.4122 11.3645 8.61142L5 9.86625V46.3439L11.3608 45.0891C17.4657 43.8892 23.7924 44.4619 29.574 46.7379C35.8372 49.2076 42.73 49.6683 49.2738 48.0548L50.0652 47.8614C51.1889 47.5848 52.1865 46.9455 52.8995 46.0453C53.6125 45.145 53.9998 44.0355 54 42.8932V16.02C53.9998 15.3553 53.846 14.6993 53.5505 14.1019C53.2549 13.5045 52.8253 12.9813 52.2942 12.5721C51.7632 12.1629 51.1446 11.8783 50.4854 11.74C49.8262 11.6018 49.1438 11.6134 48.4898 11.774C42.4566 13.2607 36.1019 12.8381 30.3284 10.5593Z",
    fill: "#33993F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBandera);
export default __webpack_public_path__ + "static/media/ic_bandera.6faf4f884db2a65923a9ec7de0f7f8e7.svg";
export { ForwardRef as ReactComponent };